var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable, { is } from 'immutable';
import { Link } from 'react-router-dom';
import rison from 'rison-node';
import ShowIf from "../../App/ShowIf";
import { withRouter } from "../../componentWrappers";
import { searchParamsFromLocationSearch } from "../../utils/routeHelpers";
import { t, Translate } from "../../I18N";
import { Icon } from "../../UI";

import { filterDocumentTypes } from "../actions/filterActions";

const getItemsToShow = (fromFilters, templates, settings) => {var _items;
  let items = fromFilters ? settings.collection.toJS().filters : [];
  if (!((_items = items) !== null && _items !== void 0 && _items.length)) {
    items = templates.toJS().map((tpl) => ({
      id: tpl._id,
      name: tpl.name
    }));
  }
  return items;
};

class DocumentTypesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ui: {},
      serverSideRender: true
    };
  }

  componentDidMount() {
    this.setState({ serverSideRender: false });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !is(this.props.selectedTemplates, nextProps.selectedTemplates) ||
      !is(this.props.settings, nextProps.settings) ||
      !is(this.props.aggregations, nextProps.aggregations) ||
      this.stateChanged(nextState));

  }

  changeAll(item, e) {
    const { selectedTemplates: selectedItems } = this.props;
    if (e.target.checked) {
      item.items.forEach((_item) => {
        if (!this.checked(_item)) {
          selectedItems.push(_item.id);
        }
      });
    }

    if (!e.target.checked) {
      item.items.forEach((_item) => {
        if (this.checked(_item)) {
          const index = selectedItems.indexOf(_item.id);
          selectedItems.splice(index, 1);
        }
      });
    }

    this.props.filterDocumentTypes(selectedItems, this.props.location, this.props.navigate);
  }

  change(item) {
    const { selectedTemplates: selectedItems } = this.props;

    if (selectedItems.includes(item.id)) {
      const index = selectedItems.indexOf(item.id);
      selectedItems.splice(index, 1);
    } else {
      selectedItems.push(item.id);
    }

    this.props.filterDocumentTypes(selectedItems, this.props.location, this.props.navigate);
  }

  toggleOptions(item, e) {
    e.preventDefault();
    if (!this.checked(item) && item.items.find((itm) => this.checked(itm))) {
      return;
    }
    const { ui } = this.state;
    ui[item.id] = !ui[item.id];
    this.setState({ ui });
  }

  aggregations(item) {
    const aggregations = this.aggs;
    const buckets =
    aggregations.all && aggregations.all._types ? aggregations.all._types.buckets : [];
    const found = buckets.find((agg) => agg.key === item.id);
    if (found) {
      return found.filtered.doc_count;
    }

    if (item.items) {
      return item.items.reduce((result, _item) => result + this.aggregations(_item), 0);
    }

    return 0;
  }

  showSubOptions(parent) {
    const toggled = this.state.ui[parent.id];
    return !!(toggled || !!(!this.checked(parent) && parent.items.find((itm) => this.checked(itm))));
  }

  checked(item) {
    if (item.items) {
      return item.items.reduce(
        (result, _item) => result && this.checked(_item),
        item.items.length > 0
      );
    }

    return this.props.selectedTemplates.includes(item.id);
  }

  stateChanged(nextState) {
    return (
      Object.keys(nextState.ui).length === Object.keys(this.state.ui).length ||
      Object.keys(nextState.ui).reduce(
        (result, key) => result || nextState.ui[key] === this.state.ui[key],
        false
      ));

  }

  optionUrl(value, query) {
    const q = rison.encode(_objectSpread(_objectSpread({},
    query), {}, {
      types: [value],
      from: 0,
      limit: 30,
      includeUnpublished: false,
      order: 'desc',
      sort: 'creationDate',
      unpublished: false,
      allAggregations: false })
    );
    return `/library/?q=${q}`;
  }

  renderSingleType(item, index) {
    const context = item.id === 'missing' ? 'System' : item.id;

    const query = searchParamsFromLocationSearch(this.props.location, 'q') || {
      filters: []
    };

    return /*#__PURE__*/(
      _jsx("li", { className: "multiselectItem", title: item.name }, index, /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "multiselectItem-input",
        value: item.id,
        id: item.id,
        onChange: this.change.bind(this, item),
        checked: this.checked(item) }
      ), /*#__PURE__*/
      _jsx("label", { className: "multiselectItem-label", htmlFor: item.id }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0,
      this.state.serverSideRender ? /*#__PURE__*/
      _jsx(Link, { to: this.optionUrl(item.id, query) }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: context }, void 0, item.name)
      ) : /*#__PURE__*/

      _jsx(Translate, { context: context }, void 0, item.name)

      )
      ), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "multiselectItem-results" }, void 0, this.aggregations(item)), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-action placeholder" })
      ));

  }

  renderGroupType(item, index) {
    return /*#__PURE__*/(
      _jsx("li", {}, index, /*#__PURE__*/
      _jsx("div", { className: "multiselectItem" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "checkbox",
        className: "form-control multiselectItem-input",
        id: item.id,
        onChange: this.changeAll.bind(this, item),
        checked: this.checked(item) }
      ), /*#__PURE__*/
      _jsx("label", { htmlFor: item.id, className: "multiselectItem-label" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-icon" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: ['far', 'square'], className: "checkbox-empty" }), /*#__PURE__*/
      _jsx(Icon, { icon: "check", className: "checkbox-checked" })
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-name" }, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, t('Filters', item.name))
      )
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-results" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, this.aggregations(item))
      ), /*#__PURE__*/
      _jsx("span", { className: "multiselectItem-action", onClick: this.toggleOptions.bind(this, item) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: this.state.ui[item.id] ? 'caret-up' : 'caret-down' })
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.showSubOptions(item) }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "multiselectChild is-active" }, void 0,
      item.items.map((_item, i) => this.renderSingleType(_item, i))
      )
      )
      ));

  }

  render() {
    const { fromFilters, templates, settings } = this.props;
    const items = getItemsToShow(fromFilters, templates, settings);
    this.aggs = this.props.aggregations.toJS();
    return /*#__PURE__*/(
      _jsx("ul", { className: "multiselect is-active" }, void 0,
      items.map((item, index) => {
        if (item.items) {
          return this.renderGroupType(item, index);
        }
        return this.renderSingleType(item, index);
      })
      ));

  }
}

DocumentTypesList.defaultProps = {
  fromFilters: true,
  templates: Immutable.fromJS([]),
  settings: {},
  aggregations: Immutable.fromJS({}),
  selectedTemplates: [],
  filterDocumentTypes: {}
};
















function mapStateToProps(state) {
  return {
    settings: state.settings,
    templates: state.templates,
    aggregations: state.library.aggregations
  };
}

//parent ts component requires ownProps to inferring types
function mapDispatchToProps(dispatch, _ownProps) {
  return bindActionCreators({ filterDocumentTypes }, dispatch);
}

export { DocumentTypesList, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentTypesList));